/* eslint-disable no-undef */
import React, { useState, useEffect, useRef } from 'react';
import './Intro.css';
import Loader from './loader'; // Import the Loader component
import MajorVirtualTunnelLogo from './media/images/Major Tunnel logo white.png'; // Import the logo
import { IoHome, IoMenu } from 'react-icons/io5';
import { RiContactsBook2Line } from 'react-icons/ri';
import { GiPositionMarker } from 'react-icons/gi';
import { IoIosInformationCircleOutline } from 'react-icons/io';
import { IoClose } from 'react-icons/io5';
import { FaLanguage } from 'react-icons/fa6';
import { MdOutline3dRotation } from 'react-icons/md';
import Gallery from './components/gallery';
import { GrGallery } from 'react-icons/gr';
import { LiaNewspaperSolid } from 'react-icons/lia';
import { TbWorld } from 'react-icons/tb';
import { CiMoneyCheck1 } from 'react-icons/ci';
import { BiSolidDrink } from 'react-icons/bi';
import { RiVideoAiLine } from 'react-icons/ri';


const Intro = ({ showPortal, handleEnterClick }) => {
  const [animationState, setAnimationState] = useState('initial'); // 'initial', 'button', 'exit'

  const [animationState1, setAnimationState1] = useState('initial'); // 'initial', 'button', 'exit'

  const [animationState2, setAnimationState2] = useState('initial');
  // controls whether floating action buttons are visible (mobile)
  const [actionsOpen, setActionsOpen] = useState(true);
  const [showGallery, setShowGallery] = useState(false);
  const [galleryLoading, setGalleryLoading] = useState(false);
  const [galleryLoadingMethod, setGalleryLoadingMethod] = useState(false);
  const [galleryLoadingMethodButton, setGalleryLoadingMethodButton] = useState(false);

  const [ismobileView, setisMobileView] = useState(false);

  const setLoadingGallery = () => {
    setGalleryLoadingMethodButton(true);
    setShowGallery(true);

    setTimeout(() => {
      setGalleryLoadingMethod(true);
      setGalleryLoadingMethodButton(false);
    }, 2000); // Simulate a 3-second loading time
  };

  // initialize actions visibility based on screen width
  useEffect(() => {
    const onResize = () => {
      const isWide = window.innerWidth > 768;
      setActionsOpen(isWide);
      setisMobileView(!isWide);
      console.log('mobile view:', !isWide);
    };

    onResize(); // run once at start
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleDownload = () => {
    const pdfUrl =
      window.location.pathname.replace('/', '') === 'eng'
        ? '/Presentazione-Major-Virtual-Tunnel-ENG.pdf'
        : '/Presentazione-Major-Virtual-Tunnel-ITA.pdf';

    // 1️⃣ Crea un link temporaneo per forzare il download
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = pdfUrl.split('/').pop(); // estrae il nome del file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // 2️⃣ Poi apri il PDF in una nuova scheda
    window.open(pdfUrl, '_blank');
  };

  const handleDownloadCartellaStampa = () => {
    const pdfUrl =
      window.location.pathname.replace('/', '') === 'eng'
        ? '/Cartella-stampa-major-virtual-tunnel.pdf'
        : '/Cartella-stampa-major-virtual-tunnel.pdf';

    // 1️⃣ Crea un link temporaneo per forzare il download
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = pdfUrl.split('/').pop(); // estrae il nome del file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // 2️⃣ Poi apri il PDF in una nuova scheda
    window.open(pdfUrl, '_blank');
  };

  const handleDownloadPricing = () => {
    const pdfUrl =
      window.location.pathname.replace('/', '') === 'eng'
        ? '/PREZZI.pdf'
        : '/PREZZI.pdf';

    // 1️⃣ Crea un link temporaneo per forzare il download
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = pdfUrl.split('/').pop(); // estrae il nome del file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // 2️⃣ Poi apri il PDF in una nuova scheda
    window.open(pdfUrl, '_blank');
  };

  const handleDownloadEvents = () => {
    const pdfUrl =
      window.location.pathname.replace('/', '') === 'eng'
        ? '/PRESENTAZIONE.pdf'
        : '/PRESENTAZIONE ITA.pdf';

    // 1️⃣ Crea un link temporaneo per forzare il download
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = pdfUrl.split('/').pop(); // estrae il nome del file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // 2️⃣ Poi apri il PDF in una nuova scheda
    window.open(pdfUrl, '_blank');
  };


  const handleButtonClick = () => {
    // Trigger a distinct exit class for the 3D Tour button
    setAnimationState('exit-tour');
    setAnimationState2('exit');
    setAnimationState1('exit-ai');
    setTimeout(() => {
      console.log('here');
      handleEnterClick(); // Call the parent function after animation
    }, 1000); // Match the duration of the exit animation
  };

  // Ref for the video element
  const videoRef = useRef(null);
  const [showUnmute, setShowUnmute] = useState(false);

  // Show unmute button if video is muted and user hasn't interacted
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = true;
      setShowUnmute(true);
    }
  }, []);

  const handleUnmute = () => {
    if (videoRef.current) {
      videoRef.current.muted = false;
      videoRef.current.volume = 1;
      videoRef.current.play();
      setShowUnmute(false);
    }
  };

  const changeLanguage = (lang) => {
    // Update the URL path and reload the page
    window.history.pushState(null, '', `/${lang}`);
    window.location.reload(); // Reload the page to apply the new language
  };

  const handleAIClick = () => {
    const url =
      window.location.pathname.replace('/', '') === 'eng'
        ? 'https://majorvisual.net/green/main/exe/?token=25&sensor=yes&type=1V&model=119&VD=40&VT=0&VRS=1&VRM=0.7&LO=1&G=F&open=CT&words=50&CO=ai2&user=161&lang=en'
        : 'https://majorvisual.net/green/main/exe/?token=25&sensor=yes&type=1V&model=119&VD=40&VT=0&VRS=1&VRM=0.7&LO=1&G=F&open=CT&words=50&CO=ai2&user=161&lang=it';
    window.location.assign(url); // Call the parent function after animation
  };

  const handleTunnelVideoClick = () => {
    const url =
      window.location.pathname.replace('/', '') === 'eng'
        ? 'https://www.youtube.com/watch?v=E9ewyd-lKBI'
        : 'https://youtu.be/iGtDtievWRc?si=u3lMIsWECbfzdceM';
    window.location.assign(url); // Call the parent function after animation
  };

  const handleButtonAIClick = () => {
    // Trigger a distinct exit class for the 3D Tour button
    setAnimationState('exit-tour');
    setAnimationState2('exit');
    setAnimationState1('exit-ai');
    console.log('here4');
    setTimeout(() => {
      handleAIClick();
    }, 1000); // Match the duration of the exit animation
    // Trigger a distinct exit class for the AI button
  };

  const videoSrc = ismobileView ? '/VIDEO MVT X SMARTPHONE.mp4' : '/VIDEO MVT X PC.mp4';

  useEffect(() => {
    if (!videoRef.current) return;

    // stop current playback
    videoRef.current.pause();

    // force video to reload the new source
    videoRef.current.load();

    // restart playback
    videoRef.current.play().catch(() => {
      /* ignore autoplay errors */
    });
  }, [videoSrc]);

  return (
    <div
      // className={`portal-overlay ${!showPortal ? 'portal-hidden' : ''}`}
      className={'portal-overlay'}
    >
      {/* Unmute button at the top of the page */}
      {showUnmute && (!actionsOpen && ismobileView) || (actionsOpen && !ismobileView)? (
        <button
          onClick={handleUnmute}
          style={{
            position: 'absolute',
            top: 20,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: animationState2 === 'initial' ? '10010' : '19000',
            background: 'rgba(0,0,0,0.8)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '12px 28px',
            fontSize: '16px',
            fontWeight: 550,
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
          }}
        >
          {window.location.pathname.replace('/', '') === 'eng' ? '🔊 Click for Sound' : '🔊 Clicca per abilitare il suono'}
        </button>
      ) : null}
      <video
        ref={videoRef}
        autoPlay
        loop
        playsInline
        className="video-bg"
        muted
        onCanPlay={() => {
          if (videoRef.current && videoRef.current.paused) {
            videoRef.current.play().catch(() => {
              /* ignore autoplay errors */
            });
          }
        }}
      >
        <source src={videoSrc} type="video/mp4" />
      </video>

      <img src={MajorVirtualTunnelLogo} alt="Major Virtual Tunnel Logo" className={`portal-logo ${animationState}`} />

      {showGallery && (
        <Gallery
          onClose={() => {
            setShowGallery(false);
            setGalleryLoadingMethod(false);
          }}
          galleryLoading={galleryLoading}
          setGalleryLoading={(e) => setGalleryLoading(e)}
          galleryLoadingMethod={galleryLoadingMethod}
        />
      )}

      <div className="loader-container" style={{ zIndex: animationState2 === 'initial' ? '10001' : '19000' }}>
        <div className="loader-wrapper" style={{ zIndex: animationState2 === 'initial' ? '10001' : '19000' }}>
          <div
            className={`loader-button ${animationState1}`}
            onClick={handleButtonAIClick}
            style={{ zIndex: animationState2 === 'initial' ? '10001' : '19000' }}
          >
            {animationState2 === 'initial' && <Loader dimensions={'160px'} />} {/* Show the loader */}
            {animationState2 === 'initial' && (
              <div className="enter-text">{window.location.pathname.replace('/', '') === 'eng' ? 'Ask our AI' : 'Chiedi al nostro AI'}</div>
            )}{' '}
            {/* Show the button text */}
            {animationState2 === 'exit' && <Loader dimensions={'160px'} />} {/* Show the loader during exit-ai */}
          </div>
        </div>
        {/* Loader/Button Animation */}
      </div>

      {/* Floating action buttons container - toggleable on mobile */}
      <div className={`floating-actions-intro ${actionsOpen ? 'open' : 'closed'}`}>
      <button
          onClick={() =>handleTunnelVideoClick()}
          style={{
            position: 'relative',
            height: '40px',
            width: '250px',
            padding: '10px 15px',
            background: 'rgba(255, 255, 255, 0.8)',
            color: 'black',
            border: 'none',
            borderTopRightRadius: '0px',
            borderTopLeftRadius: '5px',
            borderBottomRightRadius: '0px',
            borderBottomLeftRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px',
            scale: '1.2',
            zIndex: '10000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexDirection: 'row'
          }}
        >
          <RiVideoAiLine style={{ scale: '1.2' }} />
          <span style={{ marginLeft: '10px' }}>
            {window.location.pathname.replace('/', '') === 'eng' ? 'Major Virtual Tunnel' : 'Major Virtual Tunnel'}
          </span>
        </button>

        <button
          onClick={() => {
            handleDownload();
          }}
          style={{
            position: 'relative',
            height: '40px',
            width: '250px',
            padding: '10px 15px',
            background: 'rgba(255, 255, 255, 0.8)',
            color: 'black',
            border: 'none',
            borderTopRightRadius: '0px',
            borderTopLeftRadius: '5px',
            borderBottomRightRadius: '0px',
            borderBottomLeftRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px',
            scale: '1.2',
            zIndex: '10000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexDirection: 'row'
          }}
        >
          <IoIosInformationCircleOutline style={{ scale: '1.3' }} />
          <span style={{ marginLeft: '10px' }}>
            {window.location.pathname.replace('/', '') === 'eng' ? 'Major Virtual Concept' : 'Major Virtual Concept'}
          </span>
        </button>

        <button
          onClick={() => {
            window.location.assign(
              window.location.pathname.replace('/', '') === 'eng' ? 'https://www.majorvirtual.it/en' : 'https://majorvirtual.it'
            );
          }}
          style={{
            position: 'relative',
            height: '40px',
            width: '250px',
            padding: '10px 15px',
            background: 'rgba(255, 255, 255, 0.8)',
            color: 'black',
            border: 'none',
            borderTopRightRadius: '0px',
            borderTopLeftRadius: '5px',
            borderBottomRightRadius: '0px',
            borderBottomLeftRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px',
            scale: '1.2',
            zIndex: '10000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexDirection: 'row'
          }}
        >
          <TbWorld style={{ scale: '1.2' }} />
          <span style={{ marginLeft: '10px' }}>
            {window.location.pathname.replace('/', '') === 'eng' ? 'Major Virtual World' : 'Major Virtual World'}
          </span>
        </button>

        <button
          onClick={() => {
            handleDownloadPricing();
          }}
          style={{
            position: 'relative',
            height: '40px',
            width: '250px',
            padding: '10px 15px',
            background: 'rgba(255, 255, 255, 0.8)',
            color: 'black',
            border: 'none',
            borderTopRightRadius: '0px',
            borderTopLeftRadius: '5px',
            borderBottomRightRadius: '0px',
            borderBottomLeftRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px',
            scale: '1.2',
            zIndex: '10000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexDirection: 'row'
          }}
        >
          <CiMoneyCheck1 style={{ scale: '1.3' }} />
          <span style={{ marginLeft: '10px' }}>
            {window.location.pathname.replace('/', '') === 'eng' ? 'Pricing' : 'Prezzi'}
          </span>
        </button>

        <button
          onClick={() => {
            galleryLoading ? undefined : setLoadingGallery();
          }}
          style={{
            position: 'relative',
            height: '40px',
            width: '250px',
            padding: '10px 15px',
            background: 'rgba(255, 255, 255, 0.8)',
            color: 'black',
            border: 'none',
            borderTopRightRadius: '0px',
            borderTopLeftRadius: '5px',
            borderBottomRightRadius: '0px',
            borderBottomLeftRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px',
            scale: '1.2',
            zIndex: '10000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexDirection: 'row'
          }}
        >
          <GrGallery style={{ scale: '1.2' }} />
          <span style={{ marginLeft: '10px' }}>
            {window.location.pathname.replace('/', '') === 'eng'
              ? `${galleryLoadingMethodButton ? 'Loading Photos...' : 'Photos'}`
              : `${galleryLoadingMethodButton ? 'Caricamento Immagini...' : 'Immagini'}`}
          </span>
        </button>

        <button
          onClick={() => {
            handleDownloadEvents();
          }}
          style={{
            position: 'relative',
            height: '40px',
            width: '250px',
            padding: '10px 15px',
            background: 'rgba(255, 255, 255, 0.8)',
            color: 'black',
            border: 'none',
            borderTopRightRadius: '0px',
            borderTopLeftRadius: '5px',
            borderBottomRightRadius: '0px',
            borderBottomLeftRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px',
            scale: '1.2',
            zIndex: '10000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexDirection: 'row'
          }}
        >
          <BiSolidDrink style={{ scale: '1.3' }} />
          <span style={{ marginLeft: '10px' }}>
            {window.location.pathname.replace('/', '') === 'eng' ? 'Events' : 'Eventistica'}
          </span>
        </button>

        <button
          onClick={() => {
            changeLanguage(window.location.pathname.replace('/', '') === 'eng' ? '' : 'eng');
          }}
          style={{
            position: 'fixed',
            top: '180px',
            left: '20px',
            height: '50px',
            width: '50px',
            padding: '10px 15px',
            background: 'rgba(255, 255, 255, 0.8)',
            color: 'black',
            border: 'none',
            borderTopRightRadius: '5px',
            borderTopLeftRadius: '5px',
            borderBottomRightRadius: '5px',
            borderBottomLeftRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px',
            scale: '1.2',
            zIndex: '10000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row'
          }}
        >
          <span>{window.location.pathname.replace('/', '') === 'eng' ? '🇺🇸' : '🇮🇹'}</span>
        </button>

        <button
          onClick={() => {
            handleDownloadCartellaStampa();
          }}
          style={{
            position: 'relative',
            height: '40px',
            width: '250px',
            padding: '10px 15px',
            background: 'rgba(255, 255, 255, 0.8)',
            color: 'black',
            border: 'none',
            borderTopRightRadius: '0px',
            borderTopLeftRadius: '5px',
            borderBottomRightRadius: '0px',
            borderBottomLeftRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px',
            scale: '1.2',
            zIndex: '10000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexDirection: 'row'
          }}
        >
          <LiaNewspaperSolid style={{ scale: '1.3' }} />
          <span style={{ marginLeft: '10px' }}>
            {window.location.pathname.replace('/', '') === 'eng' ? 'About us' : 'About us'}
          </span>
        </button>

        <button
          onClick={() => {
            window.location.assign('https://majorvirtual.it/contacts');
          }}
          style={{
            position: 'relative',
            height: '40px',
            width: '250px',
            padding: '10px 15px',
            background: 'rgba(255, 255, 255, 0.8)',
            color: 'black',
            border: 'none',
            borderTopRightRadius: '0px',
            borderTopLeftRadius: '5px',
            borderBottomRightRadius: '0px',
            borderBottomLeftRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px',
            scale: '1.2',
            zIndex: '10000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexDirection: 'row'
          }}
        >
          <RiContactsBook2Line />
          <span style={{ marginLeft: '10px' }}>{window.location.pathname.replace('/', '') === 'eng' ? 'Contact us' : 'Contattaci'}</span>
        </button>

        <button
          onClick={() => {
            window.location.assign('https://maps.app.goo.gl/qqwssVPzCzWzm9Y3A');
          }}
          style={{
            position: 'fixed',
            top: '250px',
            left: '20px',
            height: '50px',
            width: '50px',
            padding: '10px 15px',
            background: 'rgba(255, 255, 255, 0.8)',
            color: 'black',
            border: 'none',
            borderTopRightRadius: '5px',
            borderTopLeftRadius: '5px',
            borderBottomRightRadius: '5px',
            borderBottomLeftRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px',
            scale: '1.2',
            zIndex: '10000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row'
          }}
        >
          {/* <GiPositionMarker /> */}
          <span>
            {window.location.pathname.replace('/', '') === 'eng' ? '📍' : '📍'}
          </span>
        </button>

        {/* <button
          onClick={() => {
            showPortal ? handleButtonClick() : undefined;
          }}
          style={{
            position: 'relative',
            height: '40px',
            width: '250px',
            padding: '10px 15px',
            background: 'rgba(255, 255, 255, 0.8)',
            color: 'black',
            border: 'none',
            borderTopRightRadius: '0px',
            borderTopLeftRadius: '5px',
            borderBottomRightRadius: '0px',
            borderBottomLeftRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px',
            scale: '1.2',
            zIndex: '10000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexDirection: 'row'
          }}
        >
          <MdOutline3dRotation />
          <span style={{ marginLeft: '10px' }}>
            {window.location.pathname.replace('/', '') === 'eng'
              ? `${!showPortal ? 'Loading 3D Tour' : 'Start 3D Tour'}`
              : `${!showPortal ? 'Caricamento 3D Tour' : 'Inizia 3D Tour'}`}
          </span>
        </button> */}
      </div>

      {/* Toggle button for mobile to show/hide floating actions */}
      <button
        className="actions-toggle"
        onClick={() => setActionsOpen((v) => !v)}
        aria-label="Toggle actions"
        style={{ zIndex: animationState2 === 'initial' ? '10004' : '10001' }}
      >
        {actionsOpen ? <IoClose /> : <IoMenu />}
      </button>
    </div>
  );
};

export default Intro;
